export const DUMMY_MODAL_ID = 'dummy';
